// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const IndustryBenchmarkOut = zod.object({
  "idea_count": zod.int(),
  "industry_name": zod.string(),
  "scores": zod.record(zod.string(), zod.union([zod.number(),zod.null()]))
});

export type IndustryBenchmarkOut = zod.input<typeof IndustryBenchmarkOut>;
export type IndustryBenchmarkOutOutput = zod.output<typeof IndustryBenchmarkOut>;
